import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSnackbar } from "notistack";
import { Button, Grid, Box } from "@mui/material";
import AuthService from "../../../AuthService";
import ImagemCard from "./ImagemCard";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import CloseIcon from "@mui/icons-material/Close";
import { useDropzone } from "react-dropzone";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import { PulseLoader } from "react-spinners";
import { createUUID } from "../../../utils/index";
import { DeleteObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import { DEFAULT_IMAGEBOSS_URL } from "../../../utils/S3";

function CompCadastroImagem(props) {
  const { enqueueSnackbar } = useSnackbar();

  const produtoRef = useRef(props?.produto);

  const { handleChangeProduto } = props;
  const [imagens, setImagens] = useState(produtoRef?.current?.imagens || []);
  const [showWidget, setShowWidget] = useState(false);

  let service = new AuthService();
  let profile = service.getProfile();

  // const empresaId = profile?.empresa?.id ? "/" + profile.empresa.id : "";

  // const diretorio = "qrpedir/produtos" + empresaId;
  const URL = DEFAULT_IMAGEBOSS_URL + "/cdn/";
  const URL_Thumb = DEFAULT_IMAGEBOSS_URL + "/cover:center/150x150/";
  const [selectedFile, setSelectedFile] = useState(null);

  // const config = {
  //   bucketName: "parseint",
  //   region: "sa-east-1",
  //   dirName: diretorio,
  //   accessKeyId: process.env.REACT_APP_AWS_API_ACCESS_KEY,
  //   secretAccessKey: process.env.REACT_APP_AWS_API_SECRET_KEY,
  // };

  // const configToDelete = {
  //   bucketName: "parseint",
  //   region: "sa-east-1",
  //   accessKeyId: process.env.REACT_APP_AWS_API_ACCESS_KEY,
  //   secretAccessKey: process.env.REACT_APP_AWS_API_SECRET_KEY,
  // };

  const handleFileInput = (file) => {
    if (!!file) {
      setSelectedFile(file);
    }
  };
  // const s3Client = new S3Client({
  //   region: config.region,
  //   credentials: {
  //     accessKeyId: config.accessKeyId,
  //     secretAccessKey: config.secretAccessKey,
  //   },
  // });

    // ALTERADO - A função de upload foi completamente reescrita
  const uploadFile = async (file) => {
    if (!file) return;

    try {
      // 1. Chamar seu backend para obter a URL assinada
      // Note que o service.post deve ser capaz de fazer a chamada para sua API Java
      const presignedResponse = await service.post("/S3Service/generate-presigned-url", {
        fileName: file.name,
        fileType: file.type,
        empresaId: profile.empresa.id, // Enviamos o ID da empresa aqui
      });
      
      const { uploadUrl, key } = presignedResponse;

      // 2. Fazer o upload do arquivo para o S3 com a URL recebida (usando fetch)
      const uploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (!uploadResponse.ok) {
        throw new Error("Falha no upload para o S3!");
      }

      closeUploadWidget();

      // 3. Continuar o fluxo para salvar a referência no seu banco de dados
      // O bucket é privado: a exibição passa pelo ImageBoss, nunca pela URL de upload
      const finalUrl = URL + key;

      const newFile = {
        ...selectedFile,
        url: finalUrl,
        thumbnailUrl: URL_Thumb + key, // Usamos a 'key' retornada pelo backend
        publicId: key,
      };
      setSelectedFile(newFile);

      salvarImagem(key); // Chama a função para salvar a imagem no banco
    } catch (err) {
      console.error("Upload error:", err);
      enqueueSnackbar("Erro ao fazer upload da imagem", { variant: "error" });
      closeUploadWidget();
    }
  };


  // const removeFile = async (file) => {
  //   const key = configToDelete.dirName
  //     ? `${configToDelete.dirName}/${file.publicId}`
  //     : file.publicId;

  //   const deleteClient = new S3Client({
  //     region: configToDelete.region,
  //     credentials: {
  //       accessKeyId: configToDelete.accessKeyId,
  //       secretAccessKey: configToDelete.secretAccessKey,
  //     },
  //   });

  //   try {
  //     await deleteClient.send(
  //       new DeleteObjectCommand({
  //         Bucket: configToDelete.bucketName,
  //         Key: key,
  //       })
  //     );
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //   }
  // };

  useEffect(() => {
    const produto = produtoRef?.current;
    if (!produto) return;
    produto.imagens = imagens || [];
    handleChangeProduto(produto, "SALVAR");
    //eslint-disable-next-line
  }, [imagens]);



  const salvarImagem = (publicId) => {
    const imagem = {
      produto: { id: produtoRef?.current?.id },
      url: URL,
      thumbnailUrl: URL_Thumb + publicId,
      publicId: publicId,
      ordem: produtoRef?.current?.imagens?.length + 1,
      ativo: true,
    };
    const service = new AuthService();

    service
      .post("/imagemProduto", imagem)
      .then((imagemProdutoSalva) => {
        setImagens([...imagens, imagemProdutoSalva]);
        closeUploadWidget();
      })
      .catch((err) => {
        closeUploadWidget();
        console.error(err);
        enqueueSnackbar("Erro ao salvar imagem (api)", { variant: "error" });
      });
  };

  const openUploadWidget = () => {
    setShowWidget(true);
  };

  const closeUploadWidget = () => {
    setShowWidget(false);
  };

  const handleAlterarOrdem = (imagem) => {
    const service = new AuthService();
    service
      .put("/imagemProduto", imagem)
      .then((resp) => {
        let imagensUpdate = imagens.filter((e) => e.id !== resp.id);

        imagensUpdate.push(resp);
        imagensUpdate.sort((a, b) => a.ordem - b.ordem);

        setImagens(imagensUpdate);
      })
      .catch((err) => {
        enqueueSnackbar("Erro ao mudar ordem da imagem", { variant: "error" });
      });
  };
  
  // ALTERADO - Simplificamos a função de deleção
  const handleDeleteImage = (imagem) => {
    const service = new AuthService();

    // Agora, o endpoint `/imagemProduto/${imagem.id}` no seu backend
    // deve ser responsável por deletar a referência do banco de dados E o arquivo do S3.
    service
      .delete(`/imagemProduto/${imagem.id}`)
      .then((result) => {
        let imagensUpdate = [...imagens];
        let index = imagensUpdate.findIndex((e) => e.id === imagem.id);

        imagensUpdate.splice(index, 1);
        // A chamada `removeFile(imagem)` foi REMOVIDA daqui.
        setImagens(imagensUpdate);
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Erro ao excluir imagem (api)", { variant: "error" });
      });
  };

  return (
    <div>
      {showWidget ? (
        <Box display="block" textAlign="right">
          <Button
            onClick={closeUploadWidget}
            endIcon={<CloseIcon />}
            variant="outlined"
          >
            Cancelar upload
          </Button>
        </Box>
      ) : null}
      {showWidget && (
        <MyDropzone uploadFile={uploadFile} handleFileInput={handleFileInput} />
      )}
      {imagens.length > 0 ? (
        <Grid container spacing={3}>
          {imagens.map((imagem) => (
            <Grid
              key={imagem.id}
              size={{
                xs: 12,
                sm: 4,
              }}
            >
              <ImagemCard
                imagem={imagem}
                handleDelete={handleDeleteImage}
                handleOrdemAdicionar={() => {
                  imagem.ordem += 1;
                  return handleAlterarOrdem(imagem);
                }}
                handleOrdemSubtrair={() => {
                  imagem.ordem -= 1;
                  return handleAlterarOrdem(imagem);
                }}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        "Nenhuma imagem adicionada"
      )}
      <Box pt={2}>
        <Button
          disabled={imagens.length > 2}
          onClick={openUploadWidget}
          color="primary"
          variant="contained"
          startIcon={<ImageSearchIcon />}
        >
          Adicionar imagem{" "}
          {imagens.length > 2 ? " (limite de 3 imagens atingido)" : ""}
        </Button>
      </Box>
    </div>
  );
}

function MyDropzone({ uploadFile, handleFileInput }) {
  const [files, setFiles] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    handleFileInput(acceptedFiles[0]);
    uploadFile(acceptedFiles[0]);
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );

    if (fileRejections.length > 0) {
      let error = fileRejections[0]?.errors[0]?.code;

      switch (error) {
        case "too-many-files":
          error =
            "Erro: Limite máximo de arquivos excedido, envie um arquivo de cada vez";
          break;
        case "file-too-large":
          error =
            "Erro: O tamanho do arquivo é muito grande, limite máximo " +
            maxFileSize / 1000000 +
            " Mb.";
          break;
        case "file-invalid-type":
          error = "Erro: Tipo de arquivo inválido, selecione uma imagem";
          break;
        default:
          error = "";
      }

      enqueueSnackbar(
        "Impossível adicionar este arquivo como imagem. " + error,
        { variant: "error" }
      );
    }
    //eslint-disable-next-line
  }, []);

  const maxFileSize = 5 * 1000 * 1000; //5 Mb in bytes - syze in MB * Kbyte * Byte
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    maxFiles: 1,
    maxSize: maxFileSize,
    accept: { "image/*": [] },
    onDrop,
  });

  useEffect(() => {
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
    //eslint-disable-next-line
  }, []);

  return (
    <div {...getRootProps()}>
      <Box
        mt={2}
        mb={4}
        display="flex"
        justifyContent="center"
        sx={{ p: 4, border: "4px dashed grey" }}
      >
        <input {...getInputProps()} />

        {files?.length === 0 ? (
          <>
            <PermMediaIcon style={{ marginRight: 8 }} />
            {isDragActive
              ? "Solte a imagem aqui ... "
              : "Arraste e solte alguma imagem aqui, ou clique para selecioná-la"}
          </>
        ) : (
          <PulseLoader
            color="#283454"
            size={15}
            speedMultiplier={0.42}
            loading
          />
        )}
      </Box>
    </div>
  );
}

export default CompCadastroImagem;
